import React, { useState } from "react";
import "./Courses.css";

function Courses({ departments, setDepartments }) {
  const [selectedDept, setSelectedDept] = useState(null);
  const [editingCourse, setEditingCourse] = useState(null);

  const [courseDetails, setCourseDetails] = useState({
    code: "",
    name: "",
    year: "",
    semester: "",
    batch: "",
  });

  // 🔹 Add or Update Course
  const handleSaveCourse = () => {
    if (!selectedDept) return;

    const { code, name, year, semester, batch } = courseDetails;
    if (!code || !name || !year || !semester || !batch) {
      alert("Please fill all course details.");
      return;
    }

    const updatedDepartments = departments.map((dept) => {
      if (dept.name === selectedDept.name) {
        let updatedCourses;
        if (editingCourse) {
          // 🔹 Update existing course
          updatedCourses = dept.courses.map((c) =>
            c.code === editingCourse.code ? { code, name, year, semester, batch } : c
          );
        } else {
          // 🔹 Add new course
          updatedCourses = [...dept.courses, { code, name, year, semester, batch }];
        }
        return { ...dept, courses: updatedCourses };
      }
      return dept;
    });

    setDepartments(updatedDepartments);

    // 🔹 Update selectedDept instantly so UI reflects change
    const refreshedDept = updatedDepartments.find((d) => d.name === selectedDept.name);
    setSelectedDept(refreshedDept);

    // Reset form
    setCourseDetails({ code: "", name: "", year: "", semester: "", batch: "" });
    setEditingCourse(null);
  };

  // 🔹 Delete course
  const deleteCourse = (courseCode) => {
    const updatedDepartments = departments.map((dept) => {
      if (dept.name === selectedDept.name) {
        return {
          ...dept,
          courses: dept.courses.filter((c) => c.code !== courseCode),
        };
      }
      return dept;
    });

    setDepartments(updatedDepartments);
    const refreshedDept = updatedDepartments.find((d) => d.name === selectedDept.name);
    setSelectedDept(refreshedDept);
  };

  // 🔹 Edit course
  const editCourse = (course) => {
    setCourseDetails(course);
    setEditingCourse(course);
  };

  return (
    <div className="courses-section">
      <h2>Courses</h2>

      <h3>Select a Department</h3>
      <div className="departments-grid">
        {departments.map((dept, index) => (
          <div
            key={index}
            className={`dept-card ${selectedDept?.name === dept.name ? "active" : ""}`}
            onClick={() => setSelectedDept(dept)}
          >
            {dept.name}
          </div>
        ))}
      </div>

      {selectedDept && (
        <div className="course-form">
          <h3>{editingCourse ? "Edit Course" : `Add Course for ${selectedDept.name}`}</h3>

          <input
            type="text"
            placeholder="Course Code"
            value={courseDetails.code}
            onChange={(e) => setCourseDetails({ ...courseDetails, code: e.target.value })}
          />
          <input
            type="text"
            placeholder="Course Name"
            value={courseDetails.name}
            onChange={(e) => setCourseDetails({ ...courseDetails, name: e.target.value })}
          />
          <input
            type="text"
            placeholder="Year"
            value={courseDetails.year}
            onChange={(e) => setCourseDetails({ ...courseDetails, year: e.target.value })}
          />
          <input
            type="text"
            placeholder="Semester"
            value={courseDetails.semester}
            onChange={(e) => setCourseDetails({ ...courseDetails, semester: e.target.value })}
          />
          <input
            type="text"
            placeholder="Batch"
            value={courseDetails.batch}
            onChange={(e) => setCourseDetails({ ...courseDetails, batch: e.target.value })}
          />

          <button onClick={handleSaveCourse}>
            {editingCourse ? "Update Course" : "Add Course"}
          </button>

          <h4>Courses for {selectedDept.name}</h4>
          {selectedDept.courses.length > 0 ? (
            <table className="course-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Year</th>
                  <th>Semester</th>
                  <th>Batch</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {selectedDept.courses.map((course, idx) => (
                  <tr key={idx}>
                    <td>{course.code}</td>
                    <td>{course.name}</td>
                    <td>{course.year}</td>
                    <td>{course.semester}</td>
                    <td>{course.batch}</td>
                    <td>
                      <button onClick={() => editCourse(course)}>✏️ Edit</button>
                      <button onClick={() => deleteCourse(course.code)}>❌ Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No courses added yet.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default Courses;
